import { render, staticRenderFns } from "./ProjectChatPage.vue?vue&type=template&id=4f043c9c&"
import script from "./ProjectChatPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectChatPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports